import { z } from 'zod';

// One row per consent submission. Article 7 GDPR evidence — the document
// proves the data subject gave consent at a specific version of the consent
// text. Body text is NOT stored here; replay it by looking up the cmsLegal
// entry at the recorded version.
//
// Append-only by convention. No update/delete helpers exported; bumping the
// cmsLegal version yields a NEW row, not an in-place edit (REQ-012).

export const KYC_CONSENT_KINDS = [
  'kyc_processing',
  'cross_border_transfer',
] as const;
export const KycConsentKindSchema = z.enum(KYC_CONSENT_KINDS);
export type KycConsentKind = z.infer<typeof KycConsentKindSchema>;

// Wire DTO returned to clients (and used in tests). All timestamps are ISO
// strings on the wire; Date in the Mongoose model.
export const KycConsentRecordDtoSchema = z.object({
  id: z.string(),
  user_id: z.string(),
  client_id: z.string(),
  consent_text_doc_id: z.string(),
  consent_text_version: z.number().int(),
  kind: KycConsentKindSchema,
  accepted_at: z.string(),
  hashed_ip: z.string(),
  user_agent: z.string(),
});
export type KycConsentRecordDto = z.infer<typeof KycConsentRecordDtoSchema>;

// Client-side input for `POST /api/portal/kyc/consent` (Phase B wires the
// route). Server fills in user_id / client_id / hashed_ip / user_agent /
// accepted_at — clients cannot forge those.
export const KycConsentInputSchema = z.object({
  kind: KycConsentKindSchema,
  consent_text_doc_id: z.string().min(1).max(200),
  consent_text_version: z.number().int().nonnegative(),
});
export type KycConsentInput = z.infer<typeof KycConsentInputSchema>;
